import React from "react";
import { ArrowRight, Phone, Star, MapPin } from "lucide-react";
import { siteData, realImages } from "../mock";

export default function Hero() {
  return (
    <section className="container-tight pt-8 pb-16">
      <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="fade-up">
          <div className="chip mb-6">
            <span className="w-1.5 h-1.5 bg-[#c76d4b] rounded-full" />
            {siteData.hero.kicker}
          </div>
          <h1 className="font-serif text-[#2b2620] leading-[1.02] tracking-tight">
            <span className="block text-5xl md:text-6xl lg:text-7xl font-medium">Fasciathérapie</span>
            <span className="block text-4xl md:text-5xl lg:text-6xl font-light italic text-[#c76d4b] mt-1">& Coaching sportif</span>
            <span className="block mt-4 text-xl md:text-2xl font-normal text-[#5c554c] tracking-[0.02em]">
              à domicile ou au cabinet de Saint-Orens
            </span>
          </h1>
          <p className="mt-7 text-lg text-[#5c554c] leading-relaxed max-w-xl">
            {siteData.hero.subtitle}
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="https://www.resalib.fr/praticien/120570-jean-christophe-happillon-fasciatherapeute-quint-fonsegrives"
              target="_blank"
              rel="noreferrer"
              className="btn-primary"
            >
              {siteData.hero.ctaPrimary} <ArrowRight size={16} />
            </a>
            <a href={`tel:${siteData.practitioner.phone.replace(/\s/g, "")}`} className="btn-outline">
              <Phone size={16} /> {siteData.hero.ctaSecondary}
            </a>
          </div>

          <div className="mt-10 flex items-center gap-5 flex-wrap">
            <div className="flex -space-x-3">
              <img src={siteData.practitioner.photo} alt="Jean-Christophe Happillon, fasciathérapeute et coach sport-santé à Toulouse" className="w-11 h-11 rounded-full object-cover border-2 border-[#fdfaf5]" />
              <div className="w-11 h-11 rounded-full bg-[#f5ead9] border-2 border-[#fdfaf5] flex items-center justify-center text-xs font-semibold text-[#2b2620]">JC</div>
            </div>
            <div>
              <div className="flex items-center gap-1 text-[#c76d4b]">
                {[1,2,3,4,5].map(i => <Star key={i} size={14} fill="currentColor" />)}
                <span className="text-[#2b2620] font-semibold text-sm ml-1">{siteData.practitioner.rating}</span>
              </div>
              <p className="text-xs text-[#5c554c] mt-0.5">Basé sur {siteData.practitioner.reviewsCount} avis Google</p>
            </div>
            <div className="h-10 w-px bg-[#eee5d6]" />
            <div>
              <div className="text-lg font-serif font-medium text-[#2b2620]">{siteData.practitioner.patientsHelped}</div>
              <p className="text-xs text-[#5c554c]">Personnes accompagnées</p>
            </div>
          </div>
        </div>

        <div className="relative fade-in delay-2">
          <div className="relative rounded-[2rem] overflow-hidden aspect-[4/5] shadow-2xl shadow-[#1a1815]/10">
            <img
              src={siteData.hero.heroImage}
              alt="Séance de fasciathérapie à domicile à Toulouse et Saint-Orens"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1a1815]/40 via-transparent to-transparent" />
            <div className="absolute bottom-6 left-6 right-6 bg-white/95 backdrop-blur-sm rounded-2xl p-4 flex items-center gap-3">
              <img src={siteData.practitioner.photo} alt="Jean-Christophe Happillon, coach sport-santé à domicile à Saint-Orens" className="w-12 h-12 rounded-full object-cover" />
              <div className="flex-1">
                <div className="font-semibold text-sm text-[#1a1815]">Jean-Christophe H.</div>
                <div className="flex items-center gap-1 text-xs text-[#4a4642]"><MapPin size={12} /> Toulouse & Saint-Orens</div>
              </div>
              <span className="text-xs px-2.5 py-1 rounded-full bg-[#d97757] text-white font-medium">Dispo</span>
            </div>
          </div>

          <div className="hidden md:flex absolute -top-4 -left-6 bg-white rounded-2xl shadow-xl p-4 items-center gap-3 w-56">
            <div className="w-11 h-11 rounded-xl bg-[#f0e4d5] flex items-center justify-center">
              <span className="font-serif text-lg text-[#d97757] font-semibold">10+</span>
            </div>
            <div>
              <div className="text-sm font-semibold text-[#1a1815]">Années</div>
              <div className="text-xs text-[#4a4642]">d'expérience</div>
            </div>
          </div>

          <div className="hidden md:flex absolute -bottom-6 -right-6 bg-white border border-[#eee5d6] text-[#2b2620] rounded-2xl shadow-xl p-4 items-center gap-3 w-60">
            <div className="w-11 h-11 rounded-xl bg-[#c76d4b] flex items-center justify-center text-white">
              <Star size={20} fill="currentColor" />
            </div>
            <div>
              <div className="text-sm font-semibold">Bilan offert</div>
              <div className="text-xs text-[#8a7d6a]">1ère rencontre gratuite</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
